var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "avue-crud",
    {
      attrs: { data: _vm.list, option: _vm.option, page: _vm.page },
      on: {
        "update:page": function ($event) {
          _vm.page = $event
        },
        "current-change": _vm.currentChange,
        "size-change": _vm.sizeChange,
      },
      scopedSlots: _vm._u([
        {
          key: "type",
          fn: function (scope) {
            return [
              _c("el-tag", { attrs: { size: "small", type: "danger" } }, [
                _vm._v(_vm._s(scope.label)),
              ]),
            ]
          },
        },
        {
          key: "expand",
          fn: function (props) {
            return [
              _c("pre", { staticClass: "code" }, [
                _vm._v("        " + _vm._s(props.row.stack) + "\n      "),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "template",
        { slot: "menuLeft" },
        [
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-upload", size: "small", type: "primary" },
              on: { click: _vm.send },
            },
            [_vm._v("上传服务器")]
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-delete", size: "small", type: "danger" },
              on: { click: _vm.clear },
            },
            [_vm._v("清空本地日志")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }